import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, RotateCcw } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const CompanyLogoCell = ({ company, canEdit, onChange }) => {
  const [src, setSrc] = useState(null);
  const [ver, setVer] = useState(0);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  useEffect(() => {
    let url = null;
    api.get(`/companies/${company.id}/logo`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setSrc(null));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [company.id, ver]);
  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/companies/${company.id}/logo`, fd); toast.success(`Logo di ${company.legal_name} aggiornato`); setVer((v) => v + 1); onChange?.(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); input.current.value = ""; }
  };
  const reset = async () => {
    try { await api.delete(`/companies/${company.id}/logo`); toast.success("Logo ripristinato"); setVer((v) => v + 1); onChange?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex items-center gap-2" data-testid={`company-logo-${company.code}`} onClick={(e) => e.stopPropagation()}>
      {src ? <img src={src} alt={`Logo ${company.legal_name}`} className="h-8 max-w-[96px] object-contain" data-testid={`company-logo-img-${company.code}`} />
        : <span className="text-xs text-muted-foreground" data-testid={`company-logo-none-${company.code}`}>Elysium</span>}
      {canEdit && <>
        <input ref={input} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`company-logo-input-${company.code}`} />
        <Button size="icon" variant="ghost" className="h-7 w-7" title="Carica logo" disabled={busy} onClick={() => input.current.click()} data-testid={`company-logo-upload-${company.code}`}><Upload className="h-3.5 w-3.5" /></Button>
        {company.logo_path && <Button size="icon" variant="ghost" className="h-7 w-7" title="Torna al logo predefinito" onClick={reset} data-testid={`company-logo-reset-${company.code}`}><RotateCcw className="h-3.5 w-3.5" /></Button>}
      </>}
    </div>
  );
};
